import { render, staticRenderFns } from "./InvExD_Export.vue?vue&type=template&id=5bdf3544"
import script from "./InvExD_Export.vue?vue&type=script&lang=js"
export * from "./InvExD_Export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports